import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { editPreset } from '@api/configurationComparison';

import { TIdName } from '@interfaces/common/common';

import { ESnackbarTypes } from '@enums/common';

import { PRESET_TREE, UPDATE_PRESET_TREE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateEditPreset = () => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate: updateTreePreset,
		isLoading: isLoadingUpdateTreePreset,
	} = useMutation<TIdName>({
		mutationKey: [UPDATE_PRESET_TREE],
		mutationFn: editPreset,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.updateTreePresetSuccess,
				type: ESnackbarTypes.success,
			}));

			return [queryClient.invalidateQueries([PRESET_TREE])];
		},
	});

	return { updateTreePreset, isLoadingUpdateTreePreset };
};
